import { useSearchParams } from "react-router-dom";
import CategoryBrowser from "@/pages/category/components/CategoryBrowser";
import { usePageMeta } from "@/hooks/usePageMeta";
import { tvList } from "@/mocks/tvshows";
import type { MediaItem } from "@/types";

const tvshows = tvList as MediaItem[];

export default function TvCategory() {
  const [searchParams] = useSearchParams();
  const genre = searchParams.get("genre") || "全部";

  usePageMeta({
    title: "四虎视频-电视剧分类-最新电视剧推荐",
    description:
      "四虎视频电视剧分类页面收录古装、都市、悬疑、仙侠、治愈等各类热门剧集，支持按类型、地区、年份筛选，为你推荐最新最好看的电视剧。",
    keywords: "电视剧分类,电视剧推荐,热播剧,古装剧,都市剧,悬疑剧,四虎视频电视剧",
  });

  return (
    <CategoryBrowser
      items={tvshows}
      title="电视剧分类"
      description="收录古装、都市、悬疑、仙侠、治愈等各类热门剧集，支持类型、地区、年份筛选与热度、时间、评分排序，追剧一站式搞定。"
      initialGenre={genre}
      crumbs={[{ label: "首页", path: "/" }, { label: "电视剧" }]}
    />
  );
}